var Backbone, BrowseParsedParamsHelper, handlers, parsedParams;

Backbone = require('backbone');

parsedParams = new Backbone.Model();

handlers = {};

module.exports = BrowseParsedParamsHelper = {
  setParsedParams: function(params, options) {
    parsedParams.clear({
      silent: true
    });
    parsedParams.set(params, {
      silent: true
    });
    return parsedParams.trigger('change', parsedParams, options);
  },
  getParsedParams: function() {
    return parsedParams.toJSON();
  },
  onUpdate: function(cb, key) {
    var changeHandler;
    changeHandler = function(model, options) {
      return cb(model.toJSON(), options);
    };
    if (key != null) {
      handlers[key] = changeHandler;
    }
    return parsedParams.on('change', changeHandler);
  },
  offUpdate: function(key) {
    if (handlers[key]) {
      parsedParams.off('change', handlers[key]);
      return delete handlers[key];
    }
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWRjYWJhbGxlcm8vbmFwaXN0cmFuby9idWlsZC8xNDkyNDY3OTc1Mzc5LTM3OTUyL3N0YWdpbmctMjAxNy4wNC4xN18yMi4xNS9nb29kcy9tb2R1bGVzL2Jyb3dzZS9mcm9udGVuZC9oZWxwZXJzL3BhcnNlZF9wYXJhbXMuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvYWRjYWJhbGxlcm8vbmFwaXN0cmFuby9idWlsZC8xNDkyNDY3OTc1Mzc5LTM3OTUyL3N0YWdpbmctMjAxNy4wNC4xN18yMi4xNS9nb29kcy9tb2R1bGVzL2Jyb3dzZS9mcm9udGVuZC9oZWxwZXJzL3BhcnNlZF9wYXJhbXMuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsUUFBQSxHQUFXLE9BQUEsQ0FBUSxVQUFSOztBQUNYLFlBQUEsR0FBZSxJQUFJLFFBQVEsQ0FBQyxLQUFiLENBQUE7O0FBQ2YsUUFBQSxHQUFXOztBQUdYLE1BQU0sQ0FBQyxPQUFQLEdBQWlCLHdCQUFBLEdBQ2Y7RUFBQSxlQUFBLEVBQWlCLFNBQUMsTUFBRCxFQUFTLE9BQVQ7SUFLZixZQUFZLENBQUMsS0FBYixDQUFtQjtNQUFFLE1BQUEsRUFBUSxJQUFWO0tBQW5CO0lBT0EsWUFBWSxDQUFDLEdBQWIsQ0FBaUIsTUFBakIsRUFBeUI7TUFBRSxNQUFBLEVBQVEsSUFBVjtLQUF6QjtXQUNBLFlBQVksQ0FBQyxPQUFiLENBQXFCLFFBQXJCLEVBQStCLFlBQS9CLEVBQTZDLE9BQTdDO0VBYmUsQ0FBakI7RUFlQSxlQUFBLEVBQWlCLFNBQUE7V0FDZixZQUFZLENBQUMsTUFBYixDQUFBO0VBRGUsQ0FmakI7RUFrQkEsUUFBQSxFQUFVLFNBQUMsRUFBRCxFQUFLLEdBQUw7QUFDUixRQUFBO0lBQUEsYUFBQSxHQUFnQixTQUFDLEtBQUQsRUFBUSxPQUFSO2FBQ2QsRUFBQSxDQUFHLEtBQUssQ0FBQyxNQUFOLENBQUEsQ0FBSCxFQUFtQixPQUFuQjtJQURjO0lBRWhCLElBQWlDLFdBQWpDO01BQUEsUUFBUyxDQUFBLEdBQUEsQ0FBVCxHQUFnQixjQUFoQjs7V0FDQSxZQUFZLENBQUMsRUFBYixDQUFnQixRQUFoQixFQUEwQixhQUExQjtFQUpRLENBbEJWO0VBeUJBLFNBQUEsRUFBVyxTQUFDLEdBQUQ7SUFDVCxJQUFHLFFBQVMsQ0FBQSxHQUFBLENBQVo7TUFDRSxZQUFZLENBQUMsR0FBYixDQUFpQixRQUFqQixFQUEyQixRQUFTLENBQUEsR0FBQSxDQUFwQzthQUNBLE9BQU8sUUFBUyxDQUFBLEdBQUEsRUFGbEI7O0VBRFMsQ0F6QlgifQ==
